import React from "react";

export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.9974 0.666626C9.36559 0.666626 9.66362 0.965102 9.66308 1.33329L9.65366 7.72381L10.5169 6.86188C10.7776 6.60153 11.1997 6.60153 11.4597 6.86188C11.7196 7.12223 11.719 7.54434 11.4583 7.80469L9.45533 9.80469C9.1946 10.065 8.77249 10.065 8.51253 9.80469L6.51547 7.80469C6.25551 7.54434 6.25613 7.12223 6.51686 6.86188C6.77759 6.60153 7.19971 6.60153 7.45967 6.86188L8.32033 7.72381L8.32975 1.33329C8.33029 0.965102 8.62921 0.666626 8.9974 0.666626ZM2.31992 7.99995C2.68811 7.99995 2.98615 8.29843 2.98561 8.66662L2.97775 13.9999H14.9777L14.9856 8.66662C14.9861 8.29843 15.2851 7.99995 15.6533 7.99995C16.0214 7.99995 16.3195 8.29843 16.3189 8.66662L16.3101 14.6666C16.3096 15.0348 16.0106 15.3333 15.6424 15.3333H2.30912C1.94093 15.3333 1.64289 15.0348 1.64343 14.6666L1.65227 8.66662C1.65282 8.29843 1.95173 7.99995 2.31992 7.99995Z"
      fill="#004DB2"
    />
  </svg>
);
